
export default function select2script() {
 
}